export default [
  { name: '首页', path: '/home' },
  {
    name: '景区概况', path: '/scenic-overview', children: [
      { name: '景区资讯', path: '/scenic-overview/news' },
      { name: '景区信息', path: '/scenic-overview' },
      { name: '景区影音', path: '/scenic-overview/media' },
      { name: '游客服务', path: '/scenic-overview/tourist-server' },
    ]
  },
  {
    name: '景区票务',
    path: '/dialog',
    children: [
      { name: '票务预订', path: '/dialog' },
      { name: '旅行社购票', path: '/dialog' },
    ]
  },
  {
    name: '最美瓦屋',
    path: '/best-wawu',
    children: []
  },
  {
    name: '玩转瓦屋',
    path: '/play-wawu',
    children: [
      {
        name: '美食专区',
        path: '/play-wawu/list'
      },
      {
        name: '特色商品',
        path: '/play-wawu/list'
      },
      {
        name: '旅游住宿',
        path: '/play-wawu/list'
      }
    ]
  },
  {
    name: '活动盛典',
    path: '/activity',
    children: [
      { name: '近期活动', path: '/activity' },
      { name: '往期活动', path: '/activity' },
    ]
  },
  {
    name: '探索景区',
    path: '/explore-scenic/scenic-guide',
    children: [
      { name: '景区导览', path: '/explore-scenic/scenic-guide' },
      { name: '实时风景', path: '/explore-scenic/actual-scenic' }
    ]
  },
  {
    name: '交流中心',
    path: '/talk-center',
    children: [
      { name: '游记广场', path: '/talk-center/travel-square' },
      { name: '我要留言', path: '/talk-center/publish-msg' },
      { name: '公示公告', path: '/talk-center/notice-list' }
    ]
  }
]
